import {createApp, h, markRaw} from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia, defineStore } from "pinia";
import "@/assets/style/style.scss";
import "@/assets/style/fonts.scss"; 
import environment from "@/environment";
import {clickOutside} from "@/composables/directives";
import axios from "axios";

// Globus UI KIT
import GlobusUI from "@globus/ui-kit";
import "@globus/ui-kit/dist/globus-ui-kit.css";
import "@globus/ui-kit/themes/lk.css";
import  "@globus/ui-kit/themes/globus.css";

export const useLK = defineStore({
  ...window.LKStore,
});

const app = createApp({
    mounted() {
        console.log("[START] Start NER Application v ", process.env.VUE_APP_VERSION);
        localStorage.setItem("appVersion", process.env.VUE_APP_VERSION);
        const LKStore = useLK();
        window.LKAxios(axios, LKStore);
        window.initRouterLK(LKStore, environment.settings);
        window.moduleInit(environment.settings, router, LKStore);
    },
    render: () => h(App)
});

app.directive("clickOutside", clickOutside);

const pinia = createPinia();
pinia.use(({ store }) => {
    store.router = markRaw(window.routerLK);
});
app.use(pinia);
app.use(router);
app.use(GlobusUI);

app.mount("#app");